import moment from 'moment-timezone';
import uniqBy from 'lodash/uniqBy';

const initialState = {
  events: [],
  missedCalls: [],
  notificationCount: 0,
  showNotificationCount: false,
  outgoing: null,
  incoming: null,
  modifiedCall: {},
  latestNotification: '',
  modifiedCallTime: 0,
  reopenTab: {
    data: {}
  },
  reActivateTab: {
    data: {}
  },
  fullScreen: false,
  doCall: false,
  phonePayload: null,
  resetActiveTab: false,
  callUrlData: [],
  openPhone: false
}
export default function(state = initialState, action){
    switch(action.type){
        case "ADD_CALL_EVENT":
            return {
              ...state,
              events: [...state.events, action.payload]
            };
        case "UPDATE_CALL_EVENT":
            return {
              ...state,
              events: state.events.map(item => item.data.id === action.payload.data.id ? action.payload : item)
            };
        case "DELETE_CALL_EVENT":
            return {
              ...state,
              reopenTab: {
                data: {}
              },
              reActivateTab: {
                data: {}
              },
              events: state.events.filter(item => item.data.id !== action.payload.data.id),
            };
        case "DELETE_CALL_EVENTS":
            return {
              ...state,
              reopenTab: {
                data: {}
              },
              reActivateTab: {
                data: {}
              },
              events: state.events.filter(item => {
                return action.payload.every(obj => {
                  return obj.data.id !== item.data.id
                });
              }),
          };
        case "OUTGOING_TERMINATED":
            return {
              ...state,
              outgoing: action.payload
            };
        case "INCOMING_TERMINATED":
            return {
              ...state,
              incoming: action.payload
            };
        case "INCOMING_MISSED":
            return {
              ...state,
              missedCalls: [...state.missedCalls, action.payload],
              latestNotification: action.payload.data.id,
              showNotificationCount: true,
              notificationCount: state.latestNotification !== action.payload.data.id ||
              state.notificationCount === 0
              ? state.notificationCount + 1 : state.notificationCount
            };
        case "NOTIFICATION_REMOVE":
            return {
              ...state,
              missedCalls: state.missedCalls.filter(item => item.data.id !== action.payload)
            };
        case "NOTIFICATION_OPENED":
            return {
              ...state,
              notificationCount: 0,
              showNotificationCount: false
            };
        case "REOPEN_TAB":
            return {
              ...state,
              reopenTab: action.payload,
            };
        case "REACTIVATE_TAB":
            return {
              ...state,
              reActivateTab: action.payload,
            };
        case "CHANGE_SERVICE_NAME":
            return {
              ...state,
              events: state.events.map(item => item.data.id == action.payload.id ? {...item, data: {...item.data, ...action.payload}} : item),
              modifiedCall: action.payload,
              modifiedCallTime: moment().unix()
            };
        case "MODIFY_CALL":
            return {
              ...state,
              modifiedCall: action.payload,
              modifiedCallTime: moment().unix(),
              events: state.events.map(item => item.data.id == action.payload.id ? {...item, data: {...item.data, ...action.payload}} : item),
            };
        case "FULL_SCREEN_CHANGE":
          return {
              ...state,
              fullScreen: action.payload
          };
        case "MAKE_CALL":
          return {
              ...state,
              doCall: true,
              phonePayload: action.payload
          };
        case "RESET_CALL":
          return {
              ...state,
              doCall: false,
              phonePayload: null
          };
        case "SET_RESET_ACTIVE_TAB": 
          return {
            ...state,
            resetActiveTab: action.payload
          }
        case "SET_CALL_URL_DATA": 
          return {
            ...state,
            callUrlData: [...state.events, action.payload]
          }
        case "UPDATE_CALL_EVENTS": 
          return {
            ...state,
            events: state.events.map(item => item.data.id == action.payload.id ? {...item, data: {...item.data, ...action.payload}} : item),
          }
        case "OPEN_WEBPHONE": 
          return {
            ...state,
            openPhone: true,
          }
        case "CLOSE_WEBPHONE": 
          return {
            ...state,
            openPhone: false,
          }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/callEvents.js